import { RouteObject } from "react-router";

export const InfoRoutes: RouteObject[] = [
  {
    path: "",
    async lazy() {
      const { InfoTab } = await import("jobs/Job/InfoTab");
      return { element: <InfoTab /> };
    },
    async loader(args) {
      const { jobInfoLoader } = await import("src/router/loaders/Jobs");
      return jobInfoLoader(args);
    },
    children: [
      {
        path: "job_result/:customFormId",
        async loader(args) {
          const { newJobResultingLoader } = await import("src/router/loaders/Jobs");
          return newJobResultingLoader(args);
        },
        async lazy() {
          const { JobResultModal } = await import("jobs/Job/InfoTab/JobResultModal");
          return { element: <JobResultModal /> };
        },
      },
    ],
  },
  {
    path: "custom_form",
    children: [
      {
        path: "",
        async loader(args) {
          const { newDabellaCustomFormLoader } = await import("src/router/loaders/Jobs");
          return newDabellaCustomFormLoader(args);
        },
        async lazy() {
          const { DabellaCustomFormForm } = await import("jobs/Job/InfoTab/DabellaCustomForm/DabellaCustomFormForm");
          return { element: <DabellaCustomFormForm /> };
        },
      },
      {
        path: ":customFormId",
        async loader(args) {
          const { signDabellaCustomFormLoader } = await import("src/router/loaders/Jobs");
          return signDabellaCustomFormLoader(args);
        },
        async lazy() {
          const { DabellaCustomFormSignatureRequest } =
            await import("jobs/Job/InfoTab/DabellaCustomForm/CustomFormSignatureRequest");
          return { element: <DabellaCustomFormSignatureRequest /> };
        },
      },
    ],
  },
];
